/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import {axiosInstance} from '../axiosInstance'
const getAllOrgApplicationDevices = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-device/getAll`,param).then(res => res.data)
}
const createOrgApplicationDevice = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-device/create`,app).then(res => res.data)
}
const editOrgApplicationDevice = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-device/update`,app).then(res => res.data)
}
const getOrgAppDeviceHistory = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-device/get-history`,param).then(res => res.data)
}
const getAllOrgsAppsDevicesByOrgID = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-device/getAllByOrganizationID`,param).then(res => res.data)
}
export {
    getAllOrgApplicationDevices,
    createOrgApplicationDevice,
    editOrgApplicationDevice,
    getOrgAppDeviceHistory,
    getAllOrgsAppsDevicesByOrgID
}
